import React from 'react';
import PropTypes from 'prop-types';
import ButtonDepricated from "../../../gd-components/buttons/gd-button/gd-button-ui5";


// use ButtonSubmit from -new
export default class ButtonSubmitDeprecated extends React.Component<any> {

    public form : any

    static propTypes = {
        label: PropTypes.string.isRequired,
        size: PropTypes.oneOf(['30','36']),

        icon: PropTypes.string,
        iconPosition: PropTypes.oneOf(['left','right']),

        form: PropTypes.object,

        hideIfDisabled: PropTypes.bool, // hide (no render) when form not ready for submit

        onClick: PropTypes.any,
    };

    static defaultProps = {
        iconPosition: 'left',
        size: "36"
    };

    constructor(props:any) {
        super(props);

        this.form = this.props.form;
    }

    componentDidMount() {
        if (this.form) this.form.registerSubmitButton(this);
    }

    setForm = (form:any) => {
        if (!this.form) {
            this.form = form;
            this.form.registerSubmitButton(this);
            this.forceUpdate();
        } else console.warn("ButtonSubmitNew setForm error: form already set");
    };

    onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();

        if (this.props.type === 'busy') {
            e.preventDefault();
        } else {
            if (this.form) this.form.onSubmitClick.call(this.form);
            else if(this.props.onClick) this.props.onClick();
        }
    };

    render() {
        let type = 'primary';

        if (this.form) {
            if (this.form.isSubmitting) type = "busy";
            else if (this.form.isFormValid && this.form.isFormChanged) type = "primary";
        }

        if (this.props.hideIfDisabled === true && type !== 'primary' && type !== 'busy') return false;

        return (
            <ButtonDepricated onClick={this.onClick}
                    size={this.props.size}
                    type={type}
                    label={this.props.label}
                    icon={this.props.icon}
                    iconPosition={this.props.iconPosition}
                    className={this.props.className}/>
        );
    }
}